module.exports = __webpack_public_path__ + "img/logow.7c5eea3c.png";